export default __webpack_public_path__ + "static/media/img-3.373bb9f9.png";